import React, { useEffect, useLayoutEffect, useRef } from "react";

const AutoResizingTextarea = ({ value, onChange, name, maxLength = 200, readOnly }) => {
    const textareaRef = useRef(null);

    const resizeTextarea = () => {
        if (!textareaRef.current) return;

        const textarea = textareaRef.current;
        const MIN_HEIGHT = 40;

        textarea.style.height = "auto";
        textarea.style.height = `${Math.max(textarea.scrollHeight, MIN_HEIGHT)}px`;
    };
    useEffect(() => {
        if (!textareaRef.current) return;

        const textarea = textareaRef.current;

        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    // textarea.focus();      
                    resizeTextarea();       
                }
            },
            {
                threshold: 0.3 // 30% visible
            }
        );

        observer.observe(textarea);

        return () => observer.disconnect();
    }, []);


    useLayoutEffect(() => {
        resizeTextarea();
    }, [value]);

    return (
        <div className="flex flex-col items-center ">
            <textarea
                onFocus={resizeTextarea}
                disabled={readOnly}
                ref={textareaRef}
                value={value}
                onChange={(e) => {
                    if (e.target.value.length <= maxLength) {
                        onChange(e);
                    }
                }}
                name={name}
                className="w-full max-w-lg p-2 border border-gray-300 text-sm focus:outline-none  resize-none overflow-hidden "
                placeholder={`Type up to ${maxLength} characters...`}
            />
            {/* <div className="text-sm text-gray-500 mt-1">
                {value.length}/{maxLength} characters
            </div> */}
        </div>
    );
};

export default AutoResizingTextarea;
